import {useCallback, useState} from 'react';
import countQuestionsBySeedQuestionDoc from '../../api/question/countQuestionsBySeedQuestionDoc';

export function useCountQuestionsBySeedQuestion() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const countQuestionsBySeedQuestion = useCallback(async (moduleId: string, seedQuestionId: string) => {
    setLoading(true);
    setError(undefined);
    try {
      return await countQuestionsBySeedQuestionDoc(moduleId, seedQuestionId);
    } catch (err) {
      const e = err instanceof Error ? err : new Error(String(err));
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    countQuestionsBySeedQuestion,
    loading,
    error,
  };
}
